module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LiveHotel"
    }
  }, [_c('launch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "loaded": _vm.loaded
    },
    on: {
      "closeload": _vm.closeload
    }
  }), _vm._v(" "), (_vm.isBlack) ? _c('tipsView', {
    attrs: {
      "message": "你无权观看此直播，请联系管理员"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isyxinImLoginOut) ? _c('tipsView', {
    attrs: {
      "message": "你在其他端登陆，刷新后可以重新登陆!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.TelTestShow) ? _c('TelTest', {
    staticStyle: {
      "z-index": "9900"
    },
    attrs: {
      "fans_id": _vm.fans_id,
      "ds_id": _vm.ds_id,
      "show_type": _vm.show_type,
      "need_check_bool": _vm.need_check_bool
    },
    on: {
      "whiteNumOk": _vm.whiteNumOk
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showhead),
      expression: "showhead"
    }],
    staticClass: "headtitle",
    style: ('background:' + _vm.headtitleBg)
  }, [_c('p', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.titleName))])]), _vm._v(" "), (!_vm.isBlack) ? _c('div', {
    staticClass: "player SPZBPlayer"
  }, [_c('TFPlayer', {
    ref: "tfPlayer",
    attrs: {
      "initData": _vm.initData,
      "fans_id": _vm.fans_id,
      "videoIndex": _vm.videoIndex,
      "selectPlayType": _vm.selectPlayType,
      "runObj": _vm.runObj,
      "copyrightObj": _vm.copyrightObj
    },
    on: {
      "statusChange": _vm.playerStatusChange,
      "linkTypeChange": _vm.linkTypeChange,
      "isSupportRTC": _vm.isSupportRTCCallBack,
      "unAutoPlay": _vm.unAutoPlay,
      "playFailed": _vm.playFailed,
      "playerListener": _vm.playerListener
    }
  })], 1) : _c('div', {
    staticClass: "player"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.initData && _vm.initData.direct_seeding.pic_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "floatBox",
    style: ('margin-top:' + _vm.playHeight + 'px')
  }, [(_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    staticClass: "trySee",
    style: ('opacity:' + _vm.tryOpacity)
  }, [_vm._v("\n      试看" + _vm._s(_vm.tryTime) + "秒，付费观看完整版\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tryPayBtn && !_vm.fullscr),
      expression: "tryPayBtn && !fullscr"
    }],
    staticClass: "tryPay",
    style: ('margin-top:' + _vm.barHeight + 'px'),
    on: {
      "click": _vm.onShowPay
    }
  }, [_vm._v("\n      付费\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hot && _vm.noClearScreen),
      expression: "hot && noClearScreen"
    }],
    staticClass: "view_num",
    style: ('margin-top:' + _vm.barHeight + 'px')
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "src": "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/hot_num.png"
    }
  }), _vm._v(" "), (_vm.view_num > 10000) ? [_vm._v(_vm._s(parseInt(_vm.view_num / 100) / 100) + "万")] : [_vm._v(_vm._s(_vm.view_num))]], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "window",
    on: {
      "click": _vm.swichWindow
    }
  }, [(_vm.forbid) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-g.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-w.png'
    }
  })]), _vm._v(" "), (_vm.allot_sale) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPlayUI),
      expression: "!isPlayUI"
    }],
    staticClass: "allot_btn",
    on: {
      "click": _vm.onShowAllot
    }
  }, [_c('span', [_vm._v("邀")]), _vm._v(" "), _c('span', [_vm._v("邀请好友")])]) : _vm._e(), _vm._v(" "), (_vm.shareRedexist) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareRed),
      expression: "shareRed"
    }],
    staticClass: "shareRed",
    attrs: {
      "id": "shareRed"
    }
  }, [_vm._v("\n      分享得\n      "), (_vm.shareType == 0) ? [_vm._v("红包")] : [_vm._v("卡券")]], 2) : _vm._e()]), _vm._v(" "), _c('chatlist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noClearScreen),
      expression: "noClearScreen"
    }],
    ref: "chat",
    attrs: {
      "noticeObj": _vm.noticeObj,
      "ds_id": _vm.ds_id
    }
  }), _vm._v(" "), [_c('toolBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noClearScreen),
      expression: "noClearScreen"
    }],
    attrs: {
      "fans_id": _vm.fans_id,
      "say_self": _vm.say_self,
      "isshowgift": _vm.isshowgift
    },
    on: {
      "comment": _vm.onReceivedMsgCallBack
    }
  }), _vm._v(" "), _c('goodsList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGoods),
      expression: "showGoods"
    }],
    ref: "goodsList",
    attrs: {
      "dsId": _vm.ds_id,
      "fansId": _vm.fans_id,
      "tid": _vm.tid,
      "gid": _vm.gid,
      "uid": _vm.uid,
      "channel_id": _vm.channel_id,
      "goodsIds": _vm.goodsIdsList
    },
    on: {
      "closeBtnClicked": _vm.goodsListCloseBtnClicked
    }
  })], _vm._v(" "), _c('div', {
    staticClass: "rightFunction"
  }, [(_vm.noClearScreen && (_vm.businessConfigs && (_vm.businessConfigs.student_room_link_mic_show || _vm.businessConfigs.student_room_link_mic_show == undefined)) &&
    _vm.initData && _vm.initData.direct_seeding.direct_status == 'running' && _vm.playerStatus == 2) ? _c('div', {
    staticClass: "rightfuncImage"
  }, [(_vm.linkType != 3) ? _c('img', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "src": require("../../../../statics/imgs/lianmai.png")
    },
    on: {
      "click": _vm.sendApplyLink
    }
  }) : _vm._e(), _vm._v(" "), (_vm.linkType == 3) ? _c('img', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "src": require("../../../../statics/imgs/lianmaizhong.png")
    },
    on: {
      "click": _vm.sendEndLink
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isshowCart == true) ? _c('img', {
    staticClass: "rightfuncImage",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "src": require("../../../../statics/imgs/cart-Empty.png")
    },
    on: {
      "click": _vm.onShowGoodsList
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "rightfuncImage",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_clear.png"
    },
    on: {
      "click": function($event) {
        _vm.noClearScreen = !_vm.noClearScreen
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noClearScreen),
      expression: "noClearScreen"
    }],
    staticClass: "rightfuncImage",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_qiehuan.png"
    },
    on: {
      "click": function($event) {
        _vm.showLiveWay = true
      }
    }
  })]), _vm._v(" "), (_vm.isShowLoginErr) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "z-index": "1911",
      "background": "rgba(0, 0, 0, 0.84)"
    },
    style: (_vm.loginErrroStyle)
  }, [_c('van-button', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.tryLogin
    }
  }, [_vm._v("重新登录")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weixincode"
  }, [_c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('img', {
    attrs: {
      "src": "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/title-popup.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.weixintopText))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/title-popup.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "130px"
    },
    attrs: {
      "src": _vm.weixincodeUrl
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#353535",
      "font-size": "13px",
      "margin-top": "10px"
    }
  }, [_vm._v("\n            - " + _vm._s(_vm.weixinbottomText) + " -\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.isShowQRimg = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.showLiveWay),
      callback: function($$v) {
        _vm.showLiveWay = $$v
      },
      expression: "showLiveWay"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body live-way"
  }, [_c('p', [(_vm.selectPlayType == 2) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tid),
      expression: "!tid"
    }]
  }, [(_vm.selectPlayType == 1) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")])], 1), _vm._v(" "), _c('p', [(_vm.selectPlayType == 3) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.showLiveWay = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.isShowTeacherQrCode),
      callback: function($$v) {
        _vm.isShowTeacherQrCode = $$v
      },
      expression: "isShowTeacherQrCode"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.teacher_qrcode_title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "375px"
    },
    attrs: {
      "src": _vm.teacher_qrcode_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": _vm.showTeacherQrCodeCliced
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showQQPopUp),
      callback: function($$v) {
        _vm.showQQPopUp = $$v
      },
      expression: "showQQPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("QQ授权登录")]), _vm._v(" "), _c('div', {
    staticClass: "qqBox",
    on: {
      "click": _vm.qqloginTap
    }
  }, [_c('img', {
    staticClass: "qqlogoImg",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/img/QQ1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("点击登录")])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "onlineSchoolLogin",
    style: ({
      width: '100%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showLineSchoolPopUp),
      callback: function($$v) {
        _vm.showLineSchoolPopUp = $$v
      },
      expression: "showLineSchoolPopUp"
    }
  }, [_c('div', {
    staticClass: "onlineSchoolLoginWay"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("网校账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("此课程为VIP课程，需要登录后观看")]), _vm._v(" "), _c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "account"
  }, [_c('span', {
    staticClass: "area"
  }, [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolAccount),
      expression: "onlineSchoolAccount"
    }],
    staticClass: "loginInput",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.onlineSchoolAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.loginType == 1) ? _c('div', {
    staticClass: "account"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolPassword),
      expression: "onlineSchoolPassword"
    }],
    staticClass: "loginInput",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.onlineSchoolPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolPassword = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onLIneSchoolSMSCode),
      expression: "onLIneSchoolSMSCode"
    }],
    staticClass: "loginInput passwordInput",
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.onLIneSchoolSMSCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onLIneSchoolSMSCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "sendBtn",
    attrs: {
      "size": "small",
      "disabled": _vm.onlineSendMsgNum != 0,
      "type": "primary"
    },
    on: {
      "click": _vm.onlineLineSchoolSendMsg
    }
  }, [_vm._v(_vm._s(_vm.onlineSednMsgText))])], 1), _vm._v(" "), (_vm.loginType == 1) ? _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolPWDLoginClick
    }
  }, [_vm._v("网校登录")]) : _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolLoginClick
    }
  }, [_vm._v("网校登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#10a675",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        _vm.loginType == 1 ? (_vm.loginType = 2) : (_vm.loginType = 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.loginType == 1 ? "验证码登录" : "账号密码登录"))])])], 1)])])], 1), _vm._v(" "), _c('LinkPopup', {
    attrs: {
      "isShow": _vm.linkDialogVisible,
      "linkType": _vm.linkType
    },
    on: {
      "accept": _vm.linkAccept,
      "refuse": _vm.linkRefuse
    }
  }), _vm._v(" "), (_vm.tosafariShow) ? _c('div', {
    staticClass: "tosafari"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "https://tengface-project.oss-cn-shenzhen.aliyuncs.com/tmp/quxiaofei.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.tosafariShow = false
      }
    }
  }, [_vm._v("我不需要连麦")])])])]) : _vm._e(), _vm._v(" "), (_vm.showShoppingType) ? _c('div', {
    staticClass: "shopping-cart",
    staticStyle: {
      "right": "10px",
      "bottom": "230px"
    },
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_c('div', {
    staticClass: "goods-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsInfo.cover,
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "pirce"
  }, [_c('span', [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))]), _vm._v(" "), _c('span', {
    staticClass: "go"
  }, [_vm._v("抢")])]), _vm._v(" "), _c('van-icon', {
    staticClass: "close",
    staticStyle: {
      "top": "10px",
      "right": "-4px"
    },
    attrs: {
      "name": "cross"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showShoppingType = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "shopping-dialog",
    model: {
      value: (_vm.showShoppingDialog),
      callback: function($$v) {
        _vm.showShoppingDialog = $$v
      },
      expression: "showShoppingDialog"
    }
  }, [_c('div', {
    staticClass: "shopping-dialog-content"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "goods-content"
  }, [_c('img', {
    staticClass: "goods-pic",
    attrs: {
      "src": _vm.goodsInfo.cover,
      "width": "96"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopping-btn",
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_vm._v("立即抢购")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../statics/imgs/close-white.png")
    },
    on: {
      "click": _vm.hideShoppingPop
    }
  })])]), _vm._v(" "), (_vm.showBuyTipsState) ? [_c('div', {
    staticClass: "bug-tips user-buy-goods",
    class: [_vm.showBuyGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": require("../../../../statics/imgs/home/user-buy-goods.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuyUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "bug-tips buy-goods-success",
    class: [_vm.showBuySuccessGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": require("../../../../statics/imgs/home/user-buy-goods-success.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessText))]), _vm._v(" "), (_vm.inventoryNum !== -1) ? _c('span', [_vm._v(", 库存剩余" + _vm._s(_vm.inventoryNum) + "件")]) : _vm._e()])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3c79ba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/Vertical/vertical.vue
// module id = 522
// module chunks = 0